var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('modal',{staticClass:"modal-error-placing-order",attrs:{"show-modal":true,"show-header":false,"show-footer":false}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[(_vm.title)?_c('span',{staticClass:"mpns-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('p',{staticClass:"mpns-message"},[_vm._t("content")],2),_vm._t("action")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }